/* global $ */
import { Swiper, Navigation } from 'swiper/dist/js/swiper.esm.js'

Swiper.use([Navigation])

function init() {
  $(document).ready(function() {
    // Initialize Swiper on containers that already have the Swiper structure from PHP
    const swiperContainers = $('.realties.swiper-container.realties-swiper');
    
    swiperContainers.each(function() {
      const $container = $(this);
      
      // Skip if already initialized
      if ($container.data('swiper-initialized')) {
        return;
      }
      
      // Check if there are slides
      if ($container.find('.swiper-slide').length === 0) {
        return;
      }
      
      // Initialize Swiper with navigation always configured
      const swiper = new Swiper($container[0], {
        slidesPerView: 'auto',
        freeMode: true,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: $container.find('.swiper-button-next')[0],
          prevEl: $container.find('.swiper-button-prev')[0]
        }
      });
      
      // Function to update navigation visibility based on window width
      const updateNavigation = () => {
        if (window.innerWidth < 1001) {
          // Show and enable navigation
          $container.find('.swiper-button-next, .swiper-button-prev').show();
          if (swiper.navigation) {
            swiper.navigation.update();
          }
        } else {
          // Hide navigation
          $container.find('.swiper-button-next, .swiper-button-prev').hide();
        }
      };
      
      // Initial navigation visibility
      updateNavigation();
      
      // Handle window resize to update navigation visibility
      let resizeTimer;
      $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          updateNavigation();
        }, 250);
      });
      
      // Mark as initialized
      $container.data('swiper-initialized', true);
    });
  });
}

export default {
  init
}
